import {inlineError} from '@s-ui/decorators/lib/index.js'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export class CreateLoanIdB2CTransactionsUseCase extends UseCase {
  constructor({createLoanIdTransactionsRequestFactory, transactionRepositoryFactory}) {
    super()
    this._createLoanIdTransactionsRequestFactory = createLoanIdTransactionsRequestFactory
    this._transactionRepositoryFactory = transactionRepositoryFactory
  }

  @inlineError
  async execute({adId, entry, fee, terms, withLifeInsurance, withGapInsurance}) {
    const loanIdTransactionsRequest = this._createLoanIdTransactionsRequestFactory({
      adId,
      entry,
      fee,
      terms,
      withLifeInsurance,
      withGapInsurance
    })
    const [error, loanEntity] = await this._transactionRepositoryFactory.createLoanIdB2C({loanIdTransactionsRequest})

    if (error) throw error
    return loanEntity.getLoanId()
  }
}
